import $ from 'jquery';

window.jQuery = $;
window.$ = $;

$(function () {
    $('.section-sku-slider:not(.section-sku-slider-1):not(.section-sku-slider-2) .slider-product').each(function (index, element) {
        var tagArrowLeft = $(element).data('tag-arrow-left');
        var tagArrowRight = $(element).data('tag-arrow-right');
        $(element).on('init', function (event, slick, direction) {
            $('.slick-slide a', $(element)).each(function (index2, element2) {
                var id = $(element2).data('id');
                $(element2).attr('id', id);
            });
        });
        $(element).slick({
            dots: $(element).closest('.section-sku-slider').hasClass('with-dots'),
            arrows: $(element).closest('.section-sku-slider').hasClass('with-arrows'),
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            infinite: true,
            appendDots: $('.container-dots', $(element).closest('.row')),
            prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
            nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
            //appendArrows: $('.container-arrows-products .arrows', $(element).closest('.row')),
            responsive: [
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
    $('.section-sku-slider-2 .slider-product').each(function (index, element) {
        var tagArrowLeft = $(element).data('tag-arrow-left');
        var tagArrowRight = $(element).data('tag-arrow-right');
        $(element).on('init', function (event, slick, direction) {
            $('.slick-slide a', $(element)).each(function (index2, element2) {
                var id = $(element2).data('id');
                $(element2).attr('id', id);
            });
        });
        $(element).slick({
            dots: $(element).closest('.section-sku-slider').hasClass('with-dots'),
            arrows: $(element).closest('.section-sku-slider').hasClass('with-arrows'),
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            infinite: true,
            appendDots: $('.container-dots', $(element).closest('.row')),
            prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
            nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
            //appendArrows: $('.container-arrows-products .arrows', $(element).closest('.row')),
            responsive: [
                {
                    breakpoint: 420,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
    $('.section-sku-slider-1 .slider-product').each(function (index, element) {
        var tagArrowLeft = $(element).data('tag-arrow-left');
        var tagArrowRight = $(element).data('tag-arrow-right');
        $(element).on('init', function (event, slick, direction) {
            $('.slick-slide a', $(element)).each(function (index2, element2) {
                var id = $(element2).data('id');
                $(element2).attr('id', id);
            });
        });
        $(element).slick({
            dots: true,
            arrows: $(element).closest('.section-sku-slider').hasClass('with-arrows'),
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            infinite: true,
            appendDots: $('.container-dots', $(element).closest('.row')),
            prevArrow: "<button class='slick-prev slick-arrow' aria-label='Previous' type='button' style='' id='" + tagArrowLeft + "'><div class='arrow'></div>Previous</button>",
            nextArrow: "<button class='slick-next slick-arrow' aria-label='Next' type='button' style='' id='" + tagArrowRight + "'><div class='arrow'></div>Next</button>",
            //appendArrows: $('.container-arrows-products .arrows', $(element).closest('.row')),
        });
    });
});
